import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCropHost,
  selectCtrl,
  setIsMovieSearchBarOpen,
} from "@app/global";
import { GridView, InoButton, ListView, ListGridView } from "@ino-ui/tv";
import { useTranslation } from "react-i18next";

import useKeydown from "@hooks/useKeydown";
import MovieCard from "./MovieCard";
import { MoviesContext } from "@context/moviesContext";
import "@styles/components/moviesList.scss";
import {
  selectIsMovieSearchBarOpen,
  setCtrl,
  setIsOpenMainSidebar,
  selectSelectedType,
} from "@app/global";
import Loading from "@components/common/Loading";
import { imageResizer } from "@utils/util";

const MoviesList = ({ isVertical, isLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ctrl = useSelector(selectCtrl);
  const cropHost = useSelector(selectCropHost);
  const selectedType = useSelector(selectSelectedType);
  const { moviesByGenre, dynamicContent } = useContext(MoviesContext);
  const isMovieSearchBarOpen = useSelector(selectIsMovieSearchBarOpen);

  const lastIndex = useRef(0);
  const lastRow = useRef(0);

  const [activeCategory, setActiveCategory] = useState(0);

  useEffect(() => {
    if (isMovieSearchBarOpen) {
      dispatch(setCtrl("inp"));
    } else {
      dispatch(setCtrl("moviesSeries"));
    }
  }, [isMovieSearchBarOpen]);

  const currentMovies = selectedType ? moviesByGenre[selectedType] || [] : [];

  useEffect(() => {
    setActiveCategory(0);
  }, [selectedType]);

  // useEffect(() => {
  //   const lastIndex = localStorage.getItem("lastIndex");
  //   const lastRow = localStorage.getItem("lastRow");
  //   if (lastIndex && lastRow) {
  //     lastIndex.current = lastIndex;
  //     lastRow.current = lastRow;
  //   }
  // }, []);

  useKeydown({
    isActive: ctrl === "moviesSeries" && !isMovieSearchBarOpen,
    // down: () => {
    //   if (!currentMovies?.length) return;

    //   setActiveCategory(Math.min(activeCategory + 1, currentMovies.length - 1));
    // },
    // up: () => {
    //   // if (activeCategory > 0) {
    //   //   setActiveCategory(activeCategory - 1);
    //   // } else {
    //   //   if (selectedType === "movie" || selectedType === "tv_show") {
    //   //     dispatch(setCtrl("backBtn"));
    //   //   }
    //   // }
    //   dispatch(setCtrl("backBtn"));
    // },
  });

  const onCardClick = useCallback(() => {
    localStorage.setItem("lastIndex", lastIndex.current);
    localStorage.setItem("lastRow", lastRow.current);
  }, []);

  const renderMovieCard = useCallback(
    ({ index, style, isActive, item }) => {
      return (
        <MovieCard
          id={item.id}
          key={item.id}
          style={style}
          isActive={isActive}
          name={
            item.movie_translation && item.movie_translation.name
              ? item.movie_translation.name
              : item.name
          }
          poster={`${imageResizer(cropHost, item.poster_tv || item.poster, 200, 300, "0", "jpg")}`}
          isVertical={isVertical}
          onCardClick={onCardClick}
        />
      );
    },
    [isVertical, cropHost]
  );

  const renderRows = useCallback(
    ({ index, style, isActive, item }) => {
      return (
        <ListView
          data={item.list}
          rowsCount={item.list.length}
          visibleRowsCount={3}
          itemHeight={30}
          itemWidth={20}
          onActiveChange={(row, col) => {
            lastIndex.current = col;
            lastRow.current = row;
          }}
          renderItem={renderMovieCard}
          style={style}
          itemsCount={item.list.length}
          itemsTotal={item.list.length}
          isActive={isActive}
          onLeft={() => {
            dispatch(setCtrl("mainSidebar"));
            dispatch(setIsOpenMainSidebar(true));
            setActiveCategory(index);
          }}
          onBack={() => {
            if (ctrl === "moviesSeries") {
              dispatch(setCtrl("backBtn"));
            }
          }}
          nativeControle={true}
          buffer={3}
          gap={2}
          name={item.name}
          poster={`${imageResizer(cropHost, item.poster, 200, 300, "0", "jpg")}`}
          isVertical={isVertical}
          onCardClick={onCardClick}
          key={item.id}
          id={item.id}
          onClick={() => {
            dispatch(setCtrl("moviesSeries"));
            dispatch(setIsOpenMainSidebar(false));
            navigate(`/movies/${item.id}`);
          }}
        />
      );
    },
    [isVertical, cropHost, onCardClick]
  );

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <Loading />
        </div>
      ) : (
        <>
          {selectedType === "movie" || selectedType === "tv_show" ? (
            <>
              {currentMovies && currentMovies.length && !isLoading ? (
                <div className="movies-list">
                  <ListView
                    data={currentMovies}
                    rowsCount={currentMovies.length}
                    visibleRowsCount={3}
                    itemHeight={35}
                    itemWidth={20}
                    nativeControle={true}
                    isActive={ctrl === "moviesSeries"}
                    onActiveChange={(row, col) => {
                      lastIndex.current = col;
                      lastRow.current = row;
                    }}
                    onBack={() => {
                      dispatch(setCtrl("backBtn"));
                    }}
                    onUp={() => {
                      dispatch(setCtrl("backBtn"));
                    }}
                    listType="vertical"
                    renderItem={renderRows}
                    itemsCount={5}
                    itemsTotal={currentMovies.length}
                    initialActiveIndex={
                      lastIndex.current
                        ? +lastIndex.current
                        : +localStorage.getItem("lastIndex")
                    }
                    initialRowActiveIndex={
                      lastRow.current
                        ? +lastRow.current
                        : +localStorage.getItem("lastRow")
                    }
                    buffer={20}
                    debounce={200}
                  />
                </div>
              ) : (
                <InoButton
                  classNames="no-content_button"
                  size="large"
                  onClick={() => {
                    dispatch(setCtrl("inp"));
                    dispatch(setIsOpenMainSidebar(false));
                    dispatch(setIsMovieSearchBarOpen(true));
                  }}
                  isActive={ctrl === "moviesSeries"}
                  onLeft={() => {
                    dispatch(setCtrl("mainSidebar"));
                    dispatch(setIsOpenMainSidebar(true));
                  }}
                >
                  Search
                </InoButton>
              )}
            </>
          ) : dynamicContent && dynamicContent.length ? (
            <div className="movies-list">
              <GridView
                id="gridview-1"
                uniqueKey="gridview-1"
                isActive={ctrl === "moviesSeries"}
                data={dynamicContent}
                onBack={() => {
                  dispatch(setCtrl("backBtn"));
                }}
                itemWidth={isVertical ? 35 : 20}
                itemHeight={isVertical ? 20 : 27}
                scrollOffset={10}
                rowItemsCount={3}
                gap={1}
                rowGap={4}
                onUp={() => {
                  dispatch(setCtrl("backBtn"));
                }}
                onLeft={() => {
                  dispatch(setCtrl("mainSidebar"));
                  dispatch(setIsOpenMainSidebar(true));
                }}
                bufferStart={10}
                bufferEnd={10}
                nativeControle={true}
                renderItem={({ index, style, isActive, item }) => {
                  return (
                    <div className="category-wrapper">
                      {renderMovieCard({ index, style, isActive, item })}
                    </div>
                  );
                }}
              />
            </div>
          ) : (
            <>
              <InoButton
                classNames="no-content_button"
                size="large"
                isActive={ctrl === "moviesSeries"}
                onLeft={() => {
                  dispatch(setCtrl("mainSidebar"));
                  dispatch(setIsOpenMainSidebar(true));
                }}
                onClick={() => {
                  dispatch(setCtrl("inp"));
                  dispatch(setIsOpenMainSidebar(false));
                  dispatch(setIsMovieSearchBarOpen(true));
                }}
              >
                {t("Search")}
              </InoButton>
            </>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(MoviesList);
